export default "__VITE_ASSET__9285bcba__"